import React from 'react';
import styled from 'styled-components';

function RadioInput() {
  return <Component></Component>;
}

export default RadioInput;

const Component = styled.div``;
